import React, { useEffect, useState } from "react";
import { Col, Row, CardBody, Card, Card as BootstrapCard } from "reactstrap";
import { getClientUrlDataToken, postDataWithToken } from "../../Utils/restUtils";
import { guestfetchBills, guestPaymentConfirm, guestPaymentRequest, postWalletPayment } from "../../CommonUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Transparentspinner from "../Common/Loader/Transparentspinner";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";




const PayNow = () => {
  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [apiResponse, setApiResponse] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedSales, setSelectedSales] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [useWallet, setUseWallet] = useState(false);
  const [minimumAmount, setMinimumAmount] = useState()

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    fetchBills();
  }, []);

  useEffect(() => {
    if (apiResponse?.total_dues !== undefined) {
      const initialAmount = parseFloat(apiResponse.total_dues ?? 0);
      setAmount(initialAmount.toFixed(2));
      setTotalAmount(initialAmount);
    }
  }, [apiResponse]);


  useEffect(() => {
    if (!apiResponse) return;

    const walletAmount = parseFloat(apiResponse?.wallet_amount ?? 0);
    const selectedAmount = parseFloat(totalAmount ?? 0);

    if (useWallet) {
      const payableAmount = selectedAmount > 0 ? selectedAmount : parseFloat(apiResponse?.total_dues ?? 0);
      setAmount(walletAmount >= payableAmount ? payableAmount.toFixed(2) : walletAmount.toFixed(2));
    } else {
      // Restore full amount
      const fallbackAmount = selectedAmount > 0 ? selectedAmount : parseFloat(apiResponse?.total_dues ?? 0);
      setAmount(fallbackAmount.toFixed(2));
    }
  }, [useWallet, totalAmount, apiResponse]);


  const fetchBills = async () => {
    setLoading(true);
    const response = await getClientUrlDataToken(guestfetchBills);
    if (response?.status) {
      setApiResponse(response);

      // const minAmount =response.data.length==0 ? 0 : Math.min(...response.data.map(item => item.total_dues));

      setMinimumAmount(response?.minimum_pay_amount||0)
    }
    setLoading(false);
  };

  const handleCheckboxChange = (id, amount) => {
    setSelectedItems((prevSelectedItems) => {
      let newSelection;
      const itemExists = prevSelectedItems.some((item) => item.id === id);

      if (itemExists) {
        newSelection = prevSelectedItems.filter((item) => item.id !== id);
      } else {
        newSelection = [...prevSelectedItems, { id, amount }];
      }
      const binTotal = newSelection.reduce((acc, curr) => acc + parseFloat(curr.amount), 0);
      const salesAmount = selectedSales ? parseFloat(apiResponse?.sales_due_total ?? 0) : 0;
      const newTotal = binTotal + salesAmount;

      setTotalAmount(newTotal);

      if (useWallet) {
        const walletAmount = parseFloat(apiResponse?.wallet_amount ?? 0);
        setAmount(walletAmount >= newTotal ? newTotal.toFixed(2) : walletAmount.toFixed(2));
      } else {
        setAmount(newTotal.toFixed(2));
      }

      return newSelection;
    });
  };


  const handleSalesOrderDues = (event) => {
    const checked = event.target.checked;
    setSelectedSales(checked);
    recalculateAmount(selectedItems, checked);
  };

  const recalculateAmount = (bins, isSalesChecked) => {
    const binTotal = bins.reduce((acc, curr) => acc + parseFloat(curr.amount), 0);
    const salesAmount = isSalesChecked ? parseFloat(apiResponse?.sales_due_total ?? 0) : 0;
    const newTotal = binTotal + salesAmount;

    setTotalAmount(newTotal);

    if (useWallet) {
      const walletAmount = parseFloat(apiResponse?.wallet_amount ?? 0);
      setAmount(walletAmount >= newTotal ? newTotal.toFixed(2) : walletAmount.toFixed(2));
    } else {
      setAmount(newTotal.toFixed(2));
    }
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleWallet = (isChecked) => {
    setUseWallet(isChecked);
    const walletAmount = parseFloat(apiResponse?.wallet_amount ?? 0);

    const binTotal = selectedItems.reduce((acc, curr) => acc + parseFloat(curr.amount), 0);
    const salesAmount = selectedSales ? parseFloat(apiResponse?.sales_due_total ?? 0) : 0;
    const total = binTotal + salesAmount;

    if (isChecked) {
      const payableAmount = total > 0 ? total : parseFloat(apiResponse?.total_dues ?? 0);
      setAmount(walletAmount >= payableAmount ? payableAmount.toFixed(2) : walletAmount.toFixed(2));
    } else {
      // 👇 this is the fix: recalculate selected amount
      const fallbackAmount = total > 0 ? total : parseFloat(apiResponse?.total_dues ?? 0);
      setAmount(fallbackAmount.toFixed(2));
    }
  };

  const onSubmit = async () => {
    let type = "any";
    const isBinChecked = selectedItems.length > 0;
    if (selectedSales && isBinChecked) {
      type = "bin_with_sales";
    } else if (selectedSales) {
      type = "sales_order";
    } else if (isBinChecked) {
      type = "subscription";
    }
    if (useWallet) {
      let connection_type = "any";
      if (selectedSales && isBinChecked) {
        connection_type = "any";
      } else if (selectedSales) {
        connection_type = "sales_order";
      } else if (isBinChecked) {
        connection_type = "subscription";
      }
      const selectedIds = selectedItems.map(item => item.id);
      const postData = {
        customer_id: authState?.role,
        amount: amount,
        stb_id:
          totalAmount === 0
            ? String(apiResponse?.data?.map((e) => e?.id))
            : selectedIds,
        connection_type,
        wallet_money: useWallet === true ? 1 : 0,
      };
      const paymentConfirm = await postDataWithToken(postWalletPayment, postData);
      if (paymentConfirm?.status === 200) {
        if (paymentConfirm?.data?.status === true) {
          toast.success(paymentConfirm?.data?.message);
          navigate(`/payment-success?receipt_id=${paymentConfirm?.data?.data}`);
        } else {
          toast.error(paymentConfirm?.data?.message);
        }
      } else { }
    } else {
      const postData = {
        request_from: "web",
        customer_id: authState?.role,
        amount: amount,
        bins:
          totalAmount === 0
            ? String(apiResponse?.data?.map((e) => e?.id))
            : String(selectedItems.map((item) => item.id).join(",")),
        gateway: "cybersource",
        type,
      };
      const paymentConfirm = await postDataWithToken(guestPaymentRequest, postData);
      if (paymentConfirm?.status === 200) {
        if (paymentConfirm?.data?.status === true) {
          const response = await getClientUrlDataToken(
            guestPaymentConfirm + paymentConfirm?.data?.data?.order_request_id
          );
          document.open();
          document.write(response);
          document.close();
        } else {
          toast.error(paymentConfirm?.data?.message);
        }
      } else {
        toast.error('Something went wrong');
      }
    }
  };


  return (
    <>
      {loading && <Transparentspinner />}
      <div className="pay-container">
        <Card className="p-1">
          <div className="d-flex justify-content-between">
            <div>
              <h5 className="tab-bar m-3 text-secondary">
                <Link to="/dashboard" className="text-decoration-none text-secondary">
                  Home
                </Link>
                &nbsp;&gt;&nbsp; pay
              </h5>
            </div>
          </div>
        </Card>
        <Card>
          <CardBody className="container">
            <Row>
              <div>
                {apiResponse &&
                  apiResponse?.data?.map((e, index) => (
                    <Col md="12" sm="12" xs="12" className="mb-3 mt-5" key={index}>
                      <div className="paycard-box ">
                        <BootstrapCard className="profile-field-card border">
                          <CardBody className="active-plan">
                            <div className=" d-flex justify-content-between ps-4 pe-4 pt-4 pb-4">
                              <div className="d-flex pt-2 pb-2">
                                <div className="subcription-item-bin ">
                                  <div className="table-column head">Bin Id</div>
                                  <div className="table-column">
                                    {e?.stb_no}
                                  </div>
                                </div>
                                <div className="subcription-item-dues ">
                                  <div className="table-column head">Dues</div>
                                  <div className="table-column due-color">
                                    B$ {e?.total_dues}
                                  </div>
                                </div>
                                <div className="subcription-item-address address">
                                  <div className="table-column head">
                                    Bin Address
                                  </div>
                                  <div className="table-column">
                                    {e?.service_address}
                                  </div>
                                </div>
                              </div>
                              <div className=" ">
                                <input
                                  type="checkbox"
                                  checked={selectedItems.some(
                                    (item) => item.id === e.id
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(e?.id, e?.total_dues)
                                  }
                                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                />
                              </div>
                            </div>
                          </CardBody>
                        </BootstrapCard>
                      </div>
                    </Col>
                  ))}

                <div className="pb-5 text-end sale-order-dues">
                  <div className="border rounded-5 p-3 align-items-center">
                    <span className="me-3">Sales Order Dues </span>
                    <span className="me-3 due-color">B$ {(apiResponse?.sales_due_total ?? 0).toFixed(2)}</span>
                    <input type="checkbox" onClick={handleSalesOrderDues}
                      style={{ width: "20px", height: "20px", cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
            </Row>
          </CardBody>
        </Card>

        <Card className="rounded-0">
          <CardBody className="container">
            <div className="d-flex justify-content-between align-items-center flex-wrap">

              {/* Wallet Section */}
              <div className="d-flex align-items-center gap-3">
                {apiResponse?.wallet_amount > 0 && (
                  <>
                    <label className="form-check-label d-flex align-items-center mb-0" style={{ fontSize: "1.1rem", fontWeight: "500" }}>
                      <input type="checkbox" onChange={(e) => handleWallet(e.target.checked)}
                        style={{ width: "20px", height: "20px", margin: '0px 15px', cursor: "pointer" }}
                      />
                      Use Wallet
                    </label>
                    <span className="badge bg-primary" style={{ fontSize: "1rem", padding: "6px 12px" }}>
                      B$ {apiResponse?.wallet_amount ?? 0}
                    </span>
                  </>
                )}
              </div>

              {/* Payment Section */}
              <div className="p-4 sale-order-dues d-flex justify-content-end align-items-center flex-wrap">
                <span className="me-3" style={{ fontSize: "1.1rem" }}>Total dues B$</span>


                <div style={{ width: '150px', marginRight: '20px' }}>
                  <input
                    type="number"
                    className="form-control"
                    value={amount}
                    onChange={handleAmountChange}
                    readOnly={useWallet}
                    style={{ fontWeight: "bold", fontSize: "1.3rem" }}
                    onWheel={(e) => {
                      e.target.blur();
                    }}
                  />
                  {
                    (apiResponse.total_dues < amount) &&
                    <span className="due-color" style={{ position: 'absolute', fontSize: '10px' }}>You can only pay up to B$ {apiResponse.total_dues}</span>
                  }
                  {
                    (minimumAmount > amount) &&
                    <span className="due-color" style={{ position: 'absolute', fontSize: '10px' }}>
                      Minimum payment is B$ {minimumAmount}
                    </span>}
                </div>

                {
                  (amount >= minimumAmount && amount <= apiResponse.total_dues) ?
                    <button className="btn btn-success" onClick={onSubmit}>
                      Pay Now
                    </button>
                    :
                    <button className="btn btn-success" style={{ cursor: 'not-allowed' }} disabled>
                      Pay Now
                    </button>
                }
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default PayNow;
